import React, { FunctionComponent } from 'react'
import Features from '../Cards/Features'

interface ConstructionPanelProps {
  portfolioHomeId: string
}
export const FeaturesPanel: FunctionComponent<React.PropsWithChildren<ConstructionPanelProps>> = ({
  portfolioHomeId
}) => <Features portfolioHomeId={portfolioHomeId} />
